import React from "react";
import PropTypes from "prop-types";

import { Field } from "redux-form";
import { FormattedMessage, injectIntl } from "react-intl";

import Select from "../../../../lib/components/Select";

export default injectIntl(
  class Recurring extends React.Component {
    static propTypes = {
      paymentType: PropTypes.string.isRequired,
      onMonthlyInterval: PropTypes.func.isRequired,
      onQuarterlyInterval: PropTypes.func.isRequired,
      onAnnuallyInterval: PropTypes.func.isRequired,
    };

    constructor(props, context) {
      super(props, context);
    }

    renderDurationOptions() {
      const { intl } = this.props;

      return [
        <option key={"ongoing"} value={5}>
          {intl.formatMessage({ id: "ongoing" })}
        </option>,
        <option key={"1 year"} value={1}>
          {intl.formatMessage({ id: "oneYear" })}
        </option>,
        <option key={"2 years"} value={2}>
          {intl.formatMessage({ id: "twoYears" })}
        </option>,
        <option key={"3 years"} value={3}>
          {intl.formatMessage({ id: "threeYears" })}
        </option>,
        <option key={"5 years"} value={5}>
          {intl.formatMessage({ id: "fiveYears" })}
        </option>,
      ];
    }

    renderDropdown(interval) {
      const { paymentInterval, intl } = this.props;

      if (paymentInterval !== interval) {
        return null;
      }

      return (
        <div className="billing-item-container">
          <div className="billing-item">
            <h4 className="billing-item--no-icon">
              {intl.formatMessage({ id: `${paymentInterval}Gift` })}
              <Field
                name="occurrences"
                type="text"
                className="m-sm-t"
                children={this.renderDurationOptions()}
                component={Select}
              />
            </h4>
          </div>
        </div>
      );
    }

    renderMothly() {
      const { paymentInterval, onMonthlyInterval } = this.props;

      const staticClassName = "fa fa-fw fa-lg m-md-r";

      return (
        <div className="m-md-t">
          <div
            className={
              paymentInterval === "monthly"
                ? "billing-item pointer primary-color-background white-font-color"
                : "billing-item pointer"
            }
            onClick={onMonthlyInterval}>
            <i
              className={
                paymentInterval === "monthly"
                  ? `${staticClassName} fa-check-circle-o`
                  : `${staticClassName} fa-calendar`
              }></i>
            <h5>
              <FormattedMessage id="monthly" />
            </h5>
          </div>
          {this.renderDropdown("monthly")}
        </div>
      );
    }

    renderQuarterly() {
      const { paymentInterval, onQuarterlyInterval } = this.props;

      const staticClassName = "fa fa-fw fa-lg m-md-r";

      return (
        <div>
          <div
            className={
              paymentInterval === "quarterly"
                ? "billing-item pointer primary-color-background white-font-color"
                : "billing-item pointer"
            }
            onClick={onQuarterlyInterval}>
            <i
              className={
                paymentInterval === "quarterly"
                  ? `${staticClassName} fa-check-circle-o`
                  : `${staticClassName} fa-sitemap`
              }></i>
            <h5>
              <FormattedMessage id="quarterly" />
            </h5>
          </div>
          {this.renderDropdown("quarterly")}
        </div>
      );
    }

    renderAnnually() {
      const { paymentInterval, onAnnuallyInterval } = this.props;

      const staticClassName = "fa fa-fw fa-lg m-md-r";

      return (
        <div>
          <div
            className={
              paymentInterval === "annually"
                ? "billing-item pointer primary-color-background white-font-color"
                : "billing-item pointer"
            }
            onClick={onAnnuallyInterval}>
            <i
              className={
                paymentInterval === "annually"
                  ? `${staticClassName} fa-check-circle-o`
                  : `${staticClassName} fa-certificate`
              }></i>
            <h5>
              <FormattedMessage id="annually" />
            </h5>
          </div>
          {this.renderDropdown("annually")}
        </div>
      );
    }

    render() {
      return (
        <div>
          {this.renderMothly()}
          {this.renderQuarterly()}
          {this.renderAnnually()}
        </div>
      );
    }
  },
);
